/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeInput, BaSeSmall1, BaSeTheme } from '@base/react';
import React, { useState } from 'react';
import { useMessage } from '../../../../hooks/messages/useMessage';
import { ContainerInput } from './row-avaliation-style';

function RowAvaliation({
  title,
  value,
  onValueChange,
  isLast = false,
  onSave,
}) {
  const { handleAttention } = useMessage();
  const [input, setInput] = useState(value);

  const validateInput = (value) => {
    if (value === undefined || value === '') return 'normal';
    if (Number(value) > 25) {
      return 'invalid';
    } else if (Number(value) <= 25) {
      return 'valid';
    } else {
      return 'normal';
    }
  };
  const handleChange = React.useCallback(
    (e) => {
      const newValue = e;

      if (String(newValue) === ' ') return;

      if (/^\d*$/.test(newValue)) {
        setInput(newValue);
        onValueChange(newValue);

        if (Number(newValue) > 25) {
          handleAttention('Nota da CCE deve ser de 0 a 25.');
          return;
        }
        if (newValue === '') {
          onValueChange(undefined);
          return;
        }
      }
    },
    [onValueChange, handleAttention],
  );

  return (
    <ContainerInput>
      <BaSeSmall1 isBold={isLast}>{title}</BaSeSmall1>

      <BaSeInput
        value={input}
        complement={onSave && !input && 'Campo obrigatório não informado.'}
        counterMinLength={0}
        typeInput="text"
        overrideColors={{
          complement: BaSeTheme.colors.feedbackInterface.erro60,
        }}
        size="small"
        width={150}
        //inputStatus={isValid ? 'valid' : 'invalid'}
        inputStatus={validateInput(input)}
        onChange={handleChange}
      />
    </ContainerInput>
  );
}

export default RowAvaliation;
